import { render, staticRenderFns } from "./AparelhosFaciaisPage.vue?vue&type=template&id=2d7c9093"
import script from "./AparelhosFaciaisPage.vue?vue&type=script&lang=js"
export * from "./AparelhosFaciaisPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports